/**
 * Enable audio for autoplay videos after a user click/tap.
 *
 * @param {Document} root
 */
export function initClickAudioVideos(root = document) {
  const videos = root.querySelectorAll('[data-click-audio-video]');

  videos.forEach((video) => {
    video.addEventListener('click', async () => {
      video.muted = !video.muted;

      if (!video.muted) {
        video.volume = 1;
      }

      if (video.paused) {
        try {
          await video.play();
        } catch {
          video.muted = true;
        }
      }
    });
  });
}
